"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }// src/common-components/lib/clickmap.ts
var _clamp = require('lodash/clamp'); var _clamp2 = _interopRequireDefault(_clamp);
function round(value) {
  const accuracy = 1e5;
  return _clamp2.default.call(void 0, Math.round(value * accuracy) / accuracy, 0, 100);
}
function normalizeCoordinate(coordinate, offset, maxCoordinate) {
  return round((coordinate - offset) / maxCoordinate);
}
function getIsAreaClicked(areas, { x, y }) {
  return areas.some(({ type, data }) => {
    if (type !== "rectangle") {
      return false;
    }
    const { p1, p2 } = data;
    return x >= Math.min(p1.x, p2.x) && x <= Math.max(p1.x, p2.x) && y >= Math.min(p1.y, p2.y) && y <= Math.max(p1.y, p2.y);
  });
}





exports.round = round; exports.normalizeCoordinate = normalizeCoordinate; exports.getIsAreaClicked = getIsAreaClicked;
//# sourceMappingURL=chunk-V5KDIV3P.js.map